import {
    Box,
    Center,
    Group,
    Loader,
    Stack,
    Table,
    Title
} from '@mantine/core';
import {useActivityEvents} from '../hooks/useActivityEvents';
import {ClearEventsButton} from '../buttons/ClearEventsButton';

export const IndexPage = () => {
    const {data: events, isLoading, error} = useActivityEvents();

    if (isLoading) {
        return (
            <Center>
                <Loader/>
            </Center>
        );
    }

    if (error) {
        return <Box>Error loading activity events</Box>;
    }

    return (
        <Stack gap="md">
            <Group justify="space-between">
                <Title order={2}>Activity Events</Title>
                <ClearEventsButton disabled={!events || events.length === 0}/>
            </Group>
            <Table>
                <Table.Thead>
                    <Table.Tr>
                        <Table.Th>Timestamp</Table.Th>
                        <Table.Th>Action</Table.Th>
                        <Table.Th>Details</Table.Th>
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                    {events && events.length > 0 ? (
                        events.map((event) => (
                            <Table.Tr key={event.id}>
                                <Table.Td>{new Date(event.timestamp).toLocaleString()}</Table.Td>
                                <Table.Td>{event.action}</Table.Td>
                                <Table.Td>{event.details || '-'}</Table.Td>
                            </Table.Tr>
                        ))
                    ) : (
                        <Table.Tr>
                            <Table.Td colSpan={3}>No activity events found</Table.Td>
                        </Table.Tr>
                    )}
                </Table.Tbody>
            </Table>
        </Stack>
    );
};
